import { updateRoomStatus } from "@saas/server-api/src/live-sdk";
import { addTimeDivider } from "@saas/components/src/utils/im/addTimeDivider.js";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { checkPermission } from "@saas/components/src/utils/permission";
import {
  getMessageList,
  getGroupPrivateList,
  setGroupPrivateUnread,
  getGroupPrivateUnread,
} from "@saas/server-api/src/chat";

// 节流函数
const throttle = function (fn, delay) {
  let timer = null;
  let lastTime = 0;

  return function (...args) {
    const now = Date.now();
    const remaining = delay - (now - lastTime);
    console.log("==zy==remaining", remaining, !timer);

    if (remaining <= 0) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      lastTime = now;
      fn.apply(this, args);
    } else if (!timer) {
      timer = setTimeout(() => {
        lastTime = Date.now();
        timer = null;
        fn.apply(this, args);
      }, remaining);
    }
  };
};

export default {
  computed: {
    ...mapState("live", [
      "imService",
      "roomInfo",
      "userStatus",
      "screenShareStatus",
    ]),
    ...mapState("newChat", [
      "hasMoreMessages",
      "groupSessionId",
      "messages",
      "tabList",
      "activeTab",
      "userInfo",
      "selectedMember",
      "haveMaterialPermission",
      "liveInfo",
      "replayMessage",
      "onlyShowTeacher",
      "privateSessionList",
      "showChat",
      "chatMode",
    ]),
    ...mapGetters("live", ["isShutUp", "allShutUp"]), //当前用户是否被禁言
    ...mapGetters("newChat", ["currentSessionId"]),
  },
  data() {
    return {
      input: "",
      setTimeoutTimer: 200, // 收到消息后-立马调用未读数接口，未读数还未更新
      throttleTimer: 1 * 1000, // 节流时间
    };
  },
  created() {
    // 创建一个Map对象用于存储发送失败消息实例
    this.$failMsg = new Map();
  },
  beforeDestroy() {
    this.imService.off(
      "liveGroupChatMessageReceived",
      this.handleLiveGroupChatMessageReceived
    );
    this.imService.off(
      "messageRevoked",
      this.handleLiveGroupChatMessageRevoked
    );
    this.imService.off(
      "recvMGLiveRoomCustomMsg",
      this.handleRecvMGLiveRoomCustomMsg
    );
  },
  watch: {
    showChat: {
      async handler(val) {
        if (val) {
          if (this.userInfo.isTeacher || this.userInfo.isAssistant) {
            // 老师端或助教端
            if (this.currentSessionId) {
              // 打开了私聊会话:获取最新消息列表
              const result = await this.getMsgList({
                to_user_id: this.currentSessionId,
              });
            } else if (this.activeTab === "group") {
              //获取最新消息列表
              this.getMsgList({
                lastMsgId: 0,
                only_teacher: this.onlyShowTeacher ? 1 : 0,
              });
              // 当前无私聊会话，则获取最新私聊会话列表
              if (this.privateSessionList.length === 0) {
                const res = await this.getGroupPrivateList({ page_size: 1 });
                if (res.code === 1) {
                  this.SET_PRIVATE_SESSION_LIST(res.data?.list || []);
                }
              }
            } else if (this.activeTab === "C2C") {
              const res = await this.getGroupPrivateList();
              if (res.code === 1) {
                this.SET_PRIVATE_SESSION_LIST(res.data?.list || []);
              } else {
                this.$darkMessage.error(res.message);
              }
              this.getGroupPrivateUnread();
            }
          } else {
            // 学生端：只有一个会话，直接重新获取最新消息列表
            this.getMsgList({
              lastMsgId: 0,
              only_teacher: this.onlyShowTeacher ? 1 : 0,
            });
            // 设置已读
            const res = await setGroupPrivateUnread({
              group_id: this.groupSessionId,
            });
            this.getGroupPrivateUnread();
          }
        }
      },
    },
    imService: {
      handler(val, oldVal) {
        if (val) {
          // 获取未读数
          this.getGroupPrivateUnread();
          this.handleIMListen();
          if (window.isElectron) {
            // 获取已下载文件列表
            this.getDownloadedFileList();
          }
        }
      },
      immediate: true,
    },
    userStatus: {
      handler(val) {
        this.SET_USER_INFO({
          user_id: val.user_id,
          user_name: val.nickname,
          user_role: val.user_role,
        });
      },
      immediate: true,
    },
    "roomInfo.id": {
      handler(val) {
        if (val) {
          this.SET_GROUP_SESSION_ID(String(val));
          this.SET_USER_INFO({
            isTeacher: this.roomInfo.isTeacher,
            isAssistant: this.roomInfo.isAssistant,
          });
          this.$store.commit("newChat/SET_LIVE_INFO", {
            teacher_id: this.roomInfo.teacher_id,
            assistant_teacher_id: this.roomInfo.assistant_teacher_id,
          });
          let havePermission = checkPermission([
            "action:material:file:view",
            "action:material:file:manage",
          ]);
          this.$store.commit(
            "newChat/SET_HAVE_MATERIAL_PERMISSION",
            havePermission
          );
        }
      },
      immediate: true,
    },
    "roomInfo.is_send_msg": {
      handler(val) {
        console.log("__is_send_msg", val);
        // 全员禁言/解除禁言
        const message = {
          ID: Date.now(),
          type: "system",
          systemType: "allMute",
          isMute: val === 1 ? false : true,
          handleTime: Date.now(),
        };
        this.handleIpcEvent({
          type: "message-add",
          payload: {
            message: message,
          },
        });
        if (window.ipcRenderer) {
          window.ipcRenderer.send("chat-state-update", {
            message: message,
            type: "message-add",
          });
        }
      },
    },
    screenShareStatus: {
      handler(val) {
        if (window.ipcRenderer) {
          window.ipcRenderer.send("chat-state-update", {
            screenShareStatus: val,
            type: "screenShareStatus",
          });
        }
      },
    },
  },
  methods: {
    ...mapActions("newChat", [
      "switchSession",
      "setInput",
      "setActiveTab",
      "handleIpcEvent",
    ]),
    ...mapMutations("newChat", [
      "SET_SHOW_CHAT",
      "SET_GROUP_SESSION_ID",
      "SET_USER_INFO",
      "SET_SELECTED_MEMBER",
      "ADD_MESSAGES",
      "SET_MESSAGES",
      "SET_PRIVATE_SESSION_LIST",
      "SET_PRIVATE_UNREAD",
      "SET_DEFAULT_DOWNLOAD_PATH",
      "SET_DOWNLOADED_FILE_LIST",
    ]),
    ...mapMutations("live", ["setRoomInfo"]),
    handleResendMessage(message) {
      // 从消息ID获取原始消息对象
      const messageId = message.ID;
      const originalMsg = this.$failMsg.get(messageId);

      if (!originalMsg) {
        console.error("找不到原始消息对象:", message);
        return;
      }

      // 更新消息状态为发送中
      this.handleUpdateMessage({
        ...message,
        status: "unSend",
      });

      this.imService
        .resendMessage(originalMsg)
        .then((res) => {
          console.log("==zy==resendMessage发送消息成功", res);
          this.handleUpdateMessage(res);
          // 发送成功后从 Map 中删除
          if (this.$failMsg.has(messageId)) {
            this.$failMsg.delete(messageId);
          }
        })
        .catch((err) => {
          console.log("==zy==resendMessage发送消息失败", err);
          this.handleSendFail(err);
          this.handleUpdateMessage({
            ...message,
            status: "fail",
          });
        });
    },
    async getDownloadedFileList() {
      const dirPath = this.getDefaultDownloadPath();
      this.SET_DEFAULT_DOWNLOAD_PATH(dirPath);
      const files = window.LiveElectronApi.getFileListByDir({ dirPath });
      this.SET_DOWNLOADED_FILE_LIST(files);
    },
    getDefaultDownloadPath() {
      let pathSep = window.pathSep ?? "/";
      const chatDownLoadDir = window.localStorage.getItem("chatDownLoadDir");
      return `${chatDownLoadDir}${this.groupSessionId}${pathSep}`;
    },
    async handlePrivateBack() {
      this.input = "";
      this.SET_MESSAGES([]);
      this.switchSession({});
      const res = await this.getGroupPrivateList();
      this.handleRefreshPrivateSessionList(res);
    },
    async getGroupPrivateUnread() {
      if (!this._throttledGetGroupPrivateUnread) {
        this._throttledGetGroupPrivateUnread = throttle(() => {
          setTimeout(async () => {
            const res = await getGroupPrivateUnread({
              group_id: this.groupSessionId,
            });
            this.SET_PRIVATE_UNREAD(res?.data || 0);
            if (window.ipcRenderer) {
              window.ipcRenderer.send("chat-state-update", {
                privateUnread: res?.data || 0,
                type: "set-private-unread",
              });
            }
          }, this.setTimeoutTimer);
        }, this.throttleTimer); // 1秒内只执行一次
      }

      this._throttledGetGroupPrivateUnread();
    },
    async handleSelectConversation(conversation) {
      // 先获取新会话的消息，再清空旧消息，避免闪现
      const result = await this.getMsgList({
        to_user_id: conversation.user_id,
        returnMessages: true, // 返回消息列表而不设置到store
      });

      // 获取消息成功后再切换会话和设置消息
      this.switchSession(conversation);
      if (result && result.messages) {
        this.SET_MESSAGES(result.messages);
        this.$store.commit("newChat/SET_HAS_MORE_MESSAGES", result.hasMore);

        // 广播到聊天窗口
        if (window.ipcRenderer) {
          window.ipcRenderer.send("chat-state-update", {
            messages: result.messages,
            hasMore: result.hasMore,
            type: "set-messages",
            scrollToBottom: true,
          });
        }

        // 首次加载完成后，发出事件通知需要滚动到底部
        EventBus.$emit("live-chat-scroll-to-bottom");
      }

      // 设置已读
      const res = await setGroupPrivateUnread({
        to_user_id: conversation.user_id,
        group_id: this.groupSessionId,
      });

      this.getGroupPrivateUnread();
    },
    async handleForbidClick(callback) {
      updateRoomStatus({
        id: Number(this.groupSessionId),
        is_send_msg: this.allShutUp ? 1 : 2,
      }).then((res) => {
        if (res.code === 1) {
          this.imService.sendMGLiveRoomCustomMsg({
            cmdId: 2,
            data: {
              type: "messageMute",
              data: {
                userId: "*",
                isMute: this.allShutUp ? false : true,
                time: Math.floor(Date.now() / 1000),
              },
            },
          });
          this.setRoomInfo({
            is_send_msg: this.allShutUp ? 1 : 2,
          });
        } else if (this.chatMode === "embed") {
          this.$darkMessage.error(res.message);
        }

        if (typeof callback === "function") {
          callback();
        }
        return {
          code: res.code,
          message: res.message,
        };
      });
    },
    async handleOnlyShowTeacher(callback) {
      const result = await this.getMsgList({
        lastMsgId: 0,
        only_teacher: this.onlyShowTeacher ? 0 : 1,
      });
      if (result?.hasMore !== null) {
        // 操作成功
        this.$store.commit(
          "newChat/SET_ONLY_SHOW_TEACHER",
          !this.onlyShowTeacher
        );
        if (window.ipcRenderer) {
          window.ipcRenderer.send("chat-state-update", {
            onlyShowTeacher: this.onlyShowTeacher,
            type: "only-show-teacher",
          });
        }
      }
      if (typeof callback === "function") {
        callback();
      }

      return result;
    },
    // 处理加载更多消息
    async handleLoadMoreMessages(params, callback) {
      // 如果已经没有更多消息，则不进行加载
      if (!this.hasMoreMessages) {
        if (typeof callback === "function") {
          callback();
        }
        return {
          hasMore: null,
        };
      }
      // 查找第一条非时间分割线非系统消息
      let firstNonDividerMsg = null;
      for (let i = 0; i < this.messages.length; i++) {
        if (
          !this.messages[i].isTimeDivider &&
          this.messages[i].type !== "system"
        ) {
          firstNonDividerMsg = this.messages[i];
          break;
        }
      }
      if (!firstNonDividerMsg?.ID) {
        if (typeof callback === "function") {
          callback();
        }
        return {
          hasMore: null,
        };
      }
      try {
        let params = {
          lastMsgId: firstNonDividerMsg.ID,
        };
        if (this.currentSessionId) {
          params = {
            ...params,
            to_user_id: this.currentSessionId,
          };
        } else {
          params = {
            ...params,
            only_teacher: this.onlyShowTeacher ? 1 : 0,
          };
        }
        const result = await this.getMsgList(params);
        // 如果提供了回调函数，调用它并传递结果
        if (typeof callback === "function") {
          callback();
        }
        return result;
      } catch (error) {
        console.error("加载更多消息失败:", error);
        if (typeof callback === "function") {
          callback();
        }
        return {
          hasMore: null,
        };
      }
    },
    async getMsgList({
      lastMsgId = 0,
      only_teacher = 0,
      to_user_id = 0,
      im_type = 2,
      returnMessages = false, // 新增参数：是否返回消息列表而不设置到store
    }) {
      const params = {
        key: this.groupSessionId,
        page_size: 20,
        source: 1, //直播间
        only_teacher,
        im_type,
      };
      if (to_user_id) {
        params.to_user_id = to_user_id;
      }
      // 如果有lastMsgId，添加到请求参数中
      if (lastMsgId) {
        params.id = lastMsgId;
      }
      // 包含私聊消息
      if (
        !this.userInfo?.isTeacher &&
        !this.userInfo?.isAssistant &&
        only_teacher !== 1
      ) {
        params.is_included_private_msg = 1;
      }

      try {
        const res = await getMessageList(params);
        if (res.code === 1) {
          // 处理消息数据
          let messageList = (res?.data?.list || []).map((item) => {
            // 转换消息格式为IM消息格式
            return this.imService.convertToIMMessage(item, this.userInfo);
          });
          // 反转消息列表
          messageList.reverse();
          // 添加时间分隔符
          messageList = addTimeDivider(messageList);

          // 如果只是返回消息列表，不设置到store
          if (returnMessages) {
            const hasMore = (res?.data?.list?.length || 0) >= params.page_size;
            return {
              messages: messageList,
              hasMore,
              lastMsgId: res.data.list[res.data.list.length - 1]?.id || 0,
            };
          }

          // 如果是首次加载（lastMsgId为0），则设置消息列表
          // 否则添加到现有消息列表前面（因为是向上加载历史消息）
          if (!lastMsgId) {
            this.SET_MESSAGES(messageList);
            // 首次加载完成后，发出事件通知需要滚动到底部
            EventBus.$emit("live-chat-scroll-to-bottom");
          } else {
            this.ADD_MESSAGES({
              messages: messageList,
              isHistoryMessages: true,
            });
          }
          const hasMore = (res?.data?.list?.length || 0) >= params.page_size;
          this.$store.commit("newChat/SET_HAS_MORE_MESSAGES", hasMore);

          // 广播到聊天窗口:更新整个聊天窗口的消息列表
          if (window.ipcRenderer) {
            if (!lastMsgId) {
              window.ipcRenderer.send("chat-state-update", {
                messages: this.messages,
                hasMore,
                type: "set-messages",
                scrollToBottom: true,
              });
            } else {
              window.ipcRenderer.send("chat-state-update", {
                messages: messageList,
                hasMore,
                type: "add-messages",
              });
            }
          }

          return {
            hasMore,
            lastMsgId: res.data.list[res.data.list.length - 1]?.id || 0,
          };
        } else if (this.chatMode === "embed") {
          this.$darkMessage.error(res.message);
        } else {
          return {
            code: res?.code,
            message: res?.message,
            hasMore: null,
          };
        }
      } catch (error) {
        console.error("==zy==获取消息列表失败:", error);
        return {
          hasMore: null,
        };
      }
    },

    handleIMListen() {
      this.imService.on(
        "liveGroupChatMessageReceived",
        this.handleLiveGroupChatMessageReceived
      );
      this.imService.on(
        "messageRevoked",
        this.handleLiveGroupChatMessageRevoked
      );
      this.imService.on(
        "recvMGLiveRoomCustomMsg",
        this.handleRecvMGLiveRoomCustomMsg
      );
    },
    handleLiveGroupChatMessageReceived(res) {
      console.log("==zy==handleLiveGroupChatMessageReceived", res);
      const { isPrivateMsg, privateInfo, from } = res;
      const { isTeacher = false, isAssistant = false, user_id } = this.userInfo;

      // 老师端或助教端：更新未读私聊总数
      if (isTeacher || isAssistant) {
        if (isPrivateMsg === 1 && privateInfo?.to?.id === user_id) {
          // 对自己的私聊
          if (
            this.showChat &&
            this.currentSessionId === privateInfo?.from?.id
          ) {
            // 在私聊会话中，不更新未读数
          } else {
            this.getGroupPrivateUnread();
          }
        }
      } else {
        // 学生端
        if (isPrivateMsg === 1 && privateInfo?.to?.id === user_id) {
          // 对自己的私聊
          if (this.showChat) {
            // 在私聊会话中，不更新未读数
          } else {
            this.getGroupPrivateUnread();
          }
        }
      }

      // 处理当前会话，最新消息的添加
      if (this.showChat) {
        if (isTeacher || isAssistant) {
          // 老师端或助教端
          if (this.currentSessionId) {
            //私聊会话
            if (isPrivateMsg === 1 && privateInfo?.to?.id === user_id) {
              // 自己的私聊
              if (privateInfo?.from?.id === this.currentSessionId) {
                // 是当前私聊会话
                this.handleAddMessage(res, "in");
                setTimeout(async () => {
                  // 设置已读
                  const res = await setGroupPrivateUnread({
                    to_user_id: this.currentSessionId,
                    group_id: this.groupSessionId,
                  });
                }, this.setTimeoutTimer);
              }
            }
          } else if (this.activeTab === "group") {
            // 群聊
            if (isPrivateMsg === 1) {
              // 私聊
              if (privateInfo?.to?.id === user_id) {
                this.handleAddMessage(res, "in");
              }
              if (
                this.privateSessionList.length === 0 &&
                privateInfo?.to?.id === user_id
              ) {
                // 对自己的私聊
                this.SET_PRIVATE_SESSION_LIST([
                  {
                    name: privateInfo?.from?.name,
                    user_id: privateInfo?.from?.id,
                  },
                ]);
                if (window.ipcRenderer) {
                  window.ipcRenderer.send("chat-state-update", {
                    type: "private-list",
                    privateSessionList: {
                      list: this.privateSessionList,
                    },
                  });
                }
              }
            } else {
              // 群聊
              this.handleAddMessage(res, "in");
            }
          } else if (this.activeTab === "C2C") {
            // 刷新-私聊会话列表
            if (privateInfo?.to?.id === user_id) {
              if (!this._throttledGetGroupPrivateList) {
                this._throttledGetGroupPrivateList = throttle(async () => {
                  setTimeout(async () => {
                    const res = await this.getGroupPrivateList();
                    this.handleRefreshPrivateSessionList(res);
                  }, this.setTimeoutTimer);
                }, this.throttleTimer);
              }
              this._throttledGetGroupPrivateList();
            }
          }
        } else {
          // 学生端
          if (isPrivateMsg === 1) {
            // 私聊
            if (privateInfo?.to?.id === user_id) {
              // 对自己的私聊
              if (this.onlyShowTeacher) {
                // 只看老师
                if (
                  from === this.liveInfo?.teacher_id ||
                  from === this.liveInfo?.assistant_teacher_id
                ) {
                  // 老师发的消息
                  this.handleAddMessage(res, "in");
                } else {
                  // 不是老师发的消息-不显示
                }
              } else {
                this.handleAddMessage(res, "in");
              }
              setTimeout(async () => {
                // 设置已读
                const res = await setGroupPrivateUnread({
                  group_id: this.groupSessionId,
                });
              }, this.setTimeoutTimer);
            }
          } else {
            // 群聊
            if (this.onlyShowTeacher) {
              // 只看老师
              if (
                from === this.liveInfo?.teacher_id ||
                from === this.liveInfo?.assistant_teacher_id
              ) {
                // 老师发的消息
                this.handleAddMessage(res, "in");
              } else {
                // 不是老师发的消息-不显示
              }
            } else {
              this.handleAddMessage(res, "in");
            }
          }
        }
      }
    },
    handleLiveGroupChatMessageRevoked(res) {
      console.log("handleLiveGroupChatMessageRevoked__", res);
      const data = res.data || [];
      if (data && data.length) {
        data.forEach((item) => {
          const message = this.messages.find((fItem) => {
            if (fItem.sequence) {
              return fItem.sequence === item.sequence;
            } else if (fItem.im_msg_seq) {
              return fItem.im_msg_seq === item.sequence;
            } else {
              return false;
            }
          });
          if (message) {
            const sendMessage = {
              ...message,
              type: "system",
              systemType: "revoked",
              isSelf:
                message.user_id === this.userInfo.user_id ||
                message.from === this.userInfo.user_id,
            };
            this.handleIpcEvent({
              type: "message-update",
              payload: {
                message: sendMessage,
              },
            });
            if (window.ipcRenderer) {
              window.ipcRenderer.send("chat-state-update", {
                message: sendMessage,
                type: "message-update",
              });
            }
          }
        });
      }
    },
    handleRecvMGLiveRoomCustomMsg(res) {
      console.log("recvMGLiveRoomCustomMsg__", res);
      const { type, data } = res.data || {};
      if (type === "messageMute") {
        // 禁言或者解除禁言
        this.onMessageMute(data);
      } else if (type === "xhRemoteEnterRoom") {
        // 有人进入房间
        this.onRemoteEnterRoom(data);
      } else if (type === "member_hand_up") {
        // 有人举手
        this.onMemberHandUp(data);
      }
      this.$nextTick(() => {
        EventBus.$emit("live-chat-scroll-to-bottom");
      });
    },
    handleSelectMember(member) {
      this.SET_SELECTED_MEMBER(member);
    },
    handleCreateCustomMessage(data, cloudCustomData) {
      const params = {
        to: this.groupSessionId,
        payload: {
          data: JSON.stringify(data),
          description: "",
          extension: "MGMaterialFileExt",
        },
        cloudCustomData,
      };
      const msg = this.imService.createCustomMessage(params);
      this.handleAddMessage({ ...msg, type: "custom" });
      return msg;
    },
    handleCreateFileMessage(data, cloudCustomData) {
      const params = {
        to: this.groupSessionId,
        payload: {
          file: data,
        },
        cloudCustomData,
      };
      const msg = this.imService.createFileMessage(params);
      this.handleAddMessage({ ...msg, type: "file" });
      return msg;
    },
    handleCreateImageMessage(data, cloudCustomData) {
      const params = {
        to: this.groupSessionId,
        payload: {
          file: data,
        },
        cloudCustomData,
      };
      const msg = this.imService.createImageMessage(params);
      this.handleAddMessage({ ...msg, type: "image" });
      return msg;
    },
    handleCreateTextMessage(data, cloudCustomData) {
      const params = {
        to: this.groupSessionId,
        text: data,
        type: "text",
        cloudCustomData,
      };
      const msg = this.imService.createTextMessage(params);
      this.handleAddMessage({ ...msg, type: "text" });
      return msg;
    },
    handleAddMessage(message, flowType = "out") {
      console.log("handleAddMessage__", message, this.userStatus);
      let nameCard = message.nameCard;
      if (message.from === this.userStatus.user_id) {
        // 自己发送的时候，im返回的是旧的，所以直接使用自己的昵称
        nameCard = this.userStatus.nickname;
      }
      // 只拷贝message中需要的数据
      const {
        ID,
        avatar,
        cloudCustomData,
        flow,
        from,
        nick,
        payload,
        sequence,
        type,
        to,
        time,
        status,
        message_client_time,
        showContext,
        systemType,
        isPrivateMsg,
        privateInfo,
      } = message;
      message = {
        ID,
        avatar,
        cloudCustomData,
        flow,
        from,
        nick: nameCard || nick,
        payload,
        sequence,
        type,
        to,
        time,
        status,
        message_client_time,
        showContext,
        systemType,
        isPrivateMsg,
        privateInfo,
      };
      if (flowType === "out") {
        message = this.imService.handleChatMsg(
          JSON.parse(JSON.stringify(message))
        );
      }
      this.handleIpcEvent({
        type: "message-add",
        payload: {
          message,
        },
      });
      //  todo : 拷贝报错
      // const { ID, payload, to, type, from, avatar, flow, status } = message;
      // 广播到聊天窗口
      if (window.ipcRenderer) {
        window.ipcRenderer.send("chat-state-update", {
          message,
          type: "message-add",
          scrollToBottom: true,
        });
      }

      EventBus.$emit("live-chat-scroll-to-bottom");
    },
    handleUpdateMessage(message) {
      message = this.imService.handleChatMsg(
        JSON.parse(JSON.stringify(message))
      );
      this.handleIpcEvent({
        type: "message-update",
        payload: { message },
      });
      //  todo : 拷贝报错
      // const { ID, payload, to, type, from, avatar, flow, status } = message;
      // 广播到聊天窗口
      if (window.ipcRenderer) {
        window.ipcRenderer.send("chat-state-update", {
          message,
          type: "message-update",
        });
      }
    },
    async handleSend(message) {
      let { type, data, cloudCustomData } = message;
      console.log("==zy==cloudCustomData", cloudCustomData, message);

      let createMsg = {};
      try {
        if (type === "file") {
          const { file, source } = data;
          if (source === "material") {
            createMsg = this.handleCreateCustomMessage(file, cloudCustomData);
            type = "custom";
          } else {
            // 处理序列化后的文件数据
            const deserializedFile = await this.deserializeFileData(file);
            createMsg = this.handleCreateFileMessage(
              deserializedFile,
              cloudCustomData
            );
          }
        } else if (type === "image") {
          // 处理序列化后的图片数据
          const deserializedImage = await this.deserializeFileData(data);
          console.log("deserializedImage", deserializedImage);
          createMsg = this.handleCreateImageMessage(
            deserializedImage,
            cloudCustomData
          );
        } else if (type === "text") {
          this.input = "";
          createMsg = this.handleCreateTextMessage(data, cloudCustomData);
        } else {
          console.warn("不支持的消息类型:", type);
          return;
        }

        this.imService
          .sendMessage(createMsg)
          .then((res) => {
            console.log("==zy==发送消息成功", res, this.userStatus);
            res.nick = this.userStatus.nickname || res.nick; // 发送成功拿不到群名片
            this.handleUpdateMessage(res);
            // 发送成功后从 Map 中删除
            if (this.$failMsg.has(createMsg.ID)) {
              this.$failMsg.delete(createMsg.ID);
            }
          })
          .catch((err) => {
            console.log("==zy==发送消息失败", err);
            this.handleSendFail(err);
            // 保存消息到 Map 对象中
            this.$failMsg.set(createMsg.ID, createMsg);
            this.handleUpdateMessage({
              ...createMsg,
              type,
              status: "fail",
            });
          });
      } catch (error) {
        console.error("处理消息失败:", error);
        this.$message.error("消息处理失败，请重试");
      }
    },

    handleSendFail(err) {
      let message = "";
      if (err.message === "121111") {
        //没有权限发送素材库文件
        message = "素材中心权限已关闭，无法完成发送";
        // 需要刷新权限
        this.$store.dispatch("user/getUserPermissions");
        this.$store.commit("newChat/SET_HAVE_MATERIAL_PERMISSION", false);
      } else if (err.message === "121112") {
        //消息包含敏感词
        message = "内容含敏感信息，无法发送";
      }
      console.log("==zy==message", message, this.chatMode);
      if (this.chatMode === "embed" && message) {
        this.$darkMessage.error(message);
      }
      if (window.ipcRenderer && message) {
        window.ipcRenderer.send("chat-state-update", {
          type: "show-message-fail",
          messageError: message,
          errorCode: Number(err.code),
        });
      }
    },

    // 反序列化文件数据，将 base64 转换回 File 对象
    async deserializeFileData(serializedData) {
      // 检查是否是序列化的数据（包含 content 字段）
      if (
        serializedData &&
        serializedData.content &&
        serializedData.content.startsWith("data:")
      ) {
        try {
          // 将 base64 转换为 Blob
          const response = await fetch(serializedData.content);
          const blob = await response.blob();

          // 创建新的 File 对象
          const file = new File([blob], serializedData.name, {
            type: serializedData.type,
            lastModified: serializedData.lastModified || Date.now(),
          });

          return file;
        } catch (error) {
          console.error("反序列化文件数据失败:", error);
          throw new Error("文件数据转换失败");
        }
      }

      // 如果不是序列化数据，直接返回原始数据
      return serializedData;
    },
    closeChat() {
      this.SET_SHOW_CHAT(false);
    },
    async handleTabClick(tab, targetId) {
      this.input = "";
      this.$store.commit("newChat/SET_REPLAY_MESSAGE", "");
      this.setActiveTab(tab.value);
      if (tab.value === "group") {
        this.getMsgList({
          lastMsgId: 0,
          only_teacher: this.onlyShowTeacher ? 1 : 0,
        });
      } else {
        // 私聊
        this.getGroupPrivateUnread();
        const res = await this.getGroupPrivateList();
        this.handleRefreshPrivateSessionList(res);
      }
    },
    handleRefreshPrivateSessionList(res) {
      if (res.code === 1) {
        this.SET_PRIVATE_SESSION_LIST(res.data?.list || []);
      }
      //  else if (this.chatMode !== "popup") {
      //   this.$darkMessage.error(res.message);
      // }
      if (window.ipcRenderer) {
        window.ipcRenderer.send("chat-state-update", {
          type: "private-list",
          privateSessionList: {
            list: this.privateSessionList,
            code: res.code,
            message: res.message,
          },
        });
      }
    },
    async getGroupPrivateList(params = {}) {
      const { page_size = 999, page_no = 1 } = params;
      const res = await getGroupPrivateList({
        group_id: this.groupSessionId,
        page_size,
        page_no,
      });
      return res;
    },
    handleInputChange(value) {
      // 更新本地的input数据
      this.input = value;
    },
    onMessageMute(data) {
      console.log("_onMessageMute", data);

      const { userId, isMute, time } = data;
      if (userId === "*") {
        if (!(this.roomInfo.isAssistant || this.roomInfo.isTeacher)) {
          // 全员禁言/解除禁言
          const message = {
            ID: Date.now(),
            type: "system",
            systemType: "allMute",
            isMute: isMute,
            handleTime: time,
          };
          this.handleIpcEvent({
            type: "message-add",
            payload: {
              message: message,
            },
          });
        }
      } else if (userId === this.userInfo.user_id) {
        // 自己被禁言
        const message = {
          ID: Date.now(),
          type: "system",
          systemType: "personMute",
          isMute: isMute,
          isSelf: userId === this.userInfo.user_id,
          handleTime: time,
        };
        this.handleIpcEvent({
          type: "message-add",
          payload: {
            message: message,
          },
        });
        if (window.ipcRenderer) {
          window.ipcRenderer.send("chat-state-update", {
            message: message,
            type: "message-add",
          });
        }
      }
    },
    onRemoteEnterRoom(data) {
      const { userId, time, nickname } = data;
      if (
        userId &&
        (userId.startsWith("whiteboard_") || userId.startsWith("record_"))
      ) {
        return;
      }
      const message = {
        ID: Date.now(),
        type: "system",
        systemType: "enterRoom",
        nickname,
        handleTime: time,
      };
      // 自己被禁言
      this.handleIpcEvent({
        type: "message-add",
        payload: {
          message: message,
        },
      });
      if (window.ipcRenderer) {
        window.ipcRenderer.send("chat-state-update", {
          message: message,
          type: "message-add",
        });
      }
    },
    onMemberHandUp(data) {
      const { userId, time, nickname } = data;
      const message = {
        ID: Date.now(),
        type: "system",
        systemType: "handUp",
        nickname,
        handleTime: time,
      };
      this.handleIpcEvent({
        type: "message-add",
        payload: {
          message: message,
        },
      });
      if (window.ipcRenderer) {
        window.ipcRenderer.send("chat-state-update", {
          message: message,
          type: "message-add",
        });
      }
    },
  },
};
